import styled from '@emotion/styled';
import { Label } from '../../layouts';

export const CheckboxLabel = styled(Label)`
    &&& {
        padding-left: 0;
    }
`;
